import _ from 'lodash';
import {
  RECEIVE_DEPARTMENTS,
  RECEIVE_DEPARTMENT,
  RECEIVE_JOB,
  RECEIVE_BLOG,
} from '../actions';
import DepartmentMappings from '../company-content-src/department-mappings';

const INITIAL_STATE = { departments: [], department: {}, job: {}, blogs: {} };

function getDepartmentEnabled(slug) {
  const department = _.get(DepartmentMappings, slug);
  return !_.isEmpty(department) && department.enabled;
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RECEIVE_DEPARTMENTS: {
      const departments = [];
      _.forEach(action.data.departments, (department) => {
        const slug = _.kebabCase(department.name);
        if (getDepartmentEnabled(slug)) {
          departments.push({
            ...department,
            slug,
            relativePath: `/careers/${slug}`,
          });
        }
      });
      return {
        ...state,
        departments,
      };
    }
    case RECEIVE_DEPARTMENT: {
      const slug = _.kebabCase(action.data.name);
      const response = _.map(action.data.jobs, (job) => ({
        ...job,
        jobLocation: job.location.name,
        relativePath: `/careers/job/${job.id}`,
      }));

      return {
        ...state,
        department: {
          ...action.data,
          slug,
          relativePath: `/careers/${slug}`,
          jobs: response,
        },
      };
    }
    case RECEIVE_JOB:
      return {
        ...state,
        job: {
          ...action.data,
          relativePath: `/careers/job/${action.data.id}`,
        },
      };
    case RECEIVE_BLOG:
      return {
        ...state,
        blogs: {
          ...state.blogs,
          [action.data.departmentSlug]: {
            blogPosts: action.data.blogPosts,
          },
        },
      };
    default:
      return state;
  }
};
